import customer from './modules/customer'
import order from './modules/order'
import approval from './modules/approval'
import collection from './modules/collection'
import risk from './modules/risk'
import remind from './modules/remind'
import repayReport from './modules/repayReport'
import repayOverDueReport from './modules/repayOverDueReport'
import platformCollection from './modules/platformCollection'
import custServiceWorkOrder from './modules/custServiceWorkOrder'
import collectorTotalFollow from './modules/collectorTotalFollow'
import teleMarket from "./modules/teleMarket"
import custTrans from './modules/custTrans'
import custConvertReal from './modules/custConvertReal'
import reborrowCount from './modules/reborrowCount'
import coupon from './modules/coupon'
import repaycert from './modules/repaycert'
export default {
  code: 'es',
  label: 'Tiếng Việt',
  "Remove his order": "Di chuyển đơn hàng",
  "Unfinished": "Chưa hoàn thành",
  "Dispatch order to": "Phân cho",
  "Collector account": "Tài khoản nhân viên thu hồi",
  "User Type": "Loại khách hàng",
  "Deferral rate": "Tỷ lệ gia hạn",
  "Installment as aggregation condition": "Dùng trả góp làm điều kiện kết nối",
  error: 'Lỗi',
  tips: 'Gợi ý',
  reset: 'Đặt lại',
  search: 'Tra cứu',
  save: 'Lưu',

  searchColAll: 'Tất cả',
  searchColCur: 'Hôm nay',
  searchColHis: 'Lịch sử',

  check: 'Kiểm tra',
  edit: 'Chỉnh sửa',
  more: 'Thêm',
  delete: 'Xóa',
  enter: 'Nhập',
  select: 'Chọn',
  show: 'Hiển thị',
  hide: 'Ẩn',
  confirm: 'Xác nhận',
  cancel: 'Hủy',
  sort: 'Sắp xếp',
  action: 'Thao tác',
  operation: 'Thao tác',
  add: 'Tạo mới',
  view: 'Xem',
  success: 'Thao tác thành công',
  fail: 'Thao tác thất bại',
  userName: 'Tên người dùng',
  signOut: 'Đăng xuất',
  signIn: 'Đăng nhập',
  requestFail: 'Yêu cầu thất bại, vui lòng thử lại',
  confirmDelete: 'Xác nhận xóa?',
  oldPassword: 'Mật khẩu cũ',
  password: 'Mật khẩu',
  code2: "Mã xác thực",
  newPassword: 'Mật khẩu mới',
  confirmPassword: 'Xác nhận mật khẩu',
  createRepayOrder: 'Tạo đơn hoàn trả',
  createRepayUrl: 'Tạo liên kết hoàn trả',
  repayStatusSync: 'Đồng bộ trạng thái hoàn trả',
  payoutStatusSync: 'Đồng bộ trạng thái thanh toán',
  sex: 'Giới tính',
  name: 'Họ tên',
  birthday: 'Ngày sinh',
  date: 'Ngày',
  Startdate: 'Ngày bắt đầu',
  Enddate: 'Ngày kết thúc',
  time: 'Thời gian',
  man: 'Nam',
  woman: 'Nữ',
  email: 'Email',
  phone: 'Số điện thoại',
  phoneNo: 'Số điện thoại',
  enable: 'Kích hoạt',
  disable: 'Vô hiệu',
  status: 'Trạng thái',
  remark: 'Ghi chú',
  decLateFee: 'Giảm phí phạt chậm trả',
  decCapitalFee: 'Miễn phí gia hạn',
  decCapitalAndLateFee: 'Miễn phí phí gia hạn và phí trễ',
  clearDeductionFee: 'Xóa số tiền khấu trừ',
  handle: 'Xử lý',
  reCreate: 'Tạo lại',
  flush: 'Làm mới',
  createReport: 'Tạo báo cáo',
  apply_refuse: 'Từ chối yêu cầu',
  apply_access: 'Phê duyệt yêu cầu',
  repay: 'Lấy liên kết hoàn trả',
  offlineRepay: 'Hoàn trả ngoại tuyến',
  extendRepay: 'Gia hạn thanh toán',
  exportFile: 'Xuất dữ liệu',
  display: 'Số lượng tối đa mỗi trang',
  please_enter_a_positive_integer: "Vui lòng nhập số nguyên dương",
  close: 'Đóng',
  feeName: 'Tên phí',
  chargeNode: 'Nút thu',
  chargeStandard: 'Tiêu chuẩn thu',
  effectiveTime: 'Thời gian hiệu lực',
  pleaseInput: 'Vui lòng nhập',
  selectTime: 'Chọn thời gian',
  loanRatio: 'Tỷ lệ vay',
  fixedAmount: 'Số tiền cố định',
  loanDeduct: 'Khấu trừ khi giải ngân',
  applyDeduct: 'Khấu trừ khi nộp đơn',
  dueDeduct: 'Khấu trừ khi đến hạn',
  repayDeduct: 'Khấu trừ khi trả nợ',
  platformServiceFee: 'Phí dịch vụ nền tảng',
  applicableObject: 'Đối tượng áp dụng',
  individualAndEnterprise: 'Cá nhân + Doanh nghiệp',
  withdrawalFee: 'Phí rút tiền',
  collectedAtWithdrawal: 'Thu khi rút tiền',
  investmentAmountRatio: 'Tỷ lệ số tiền đầu tư',
  productName: 'Tên sản phẩm',
  productType: 'Loại sản phẩm',
  receiptMode: 'Thu phí trước / thu phí sau',
  preCollected: 'Thu trước',
  postCollected: 'Thu sau',
  formalProduct: 'Sản phẩm chính thức',
  submissionProduct: 'Sản phẩm tải lên',
  productDetails: 'Chi tiết sản phẩm',
  productConfigDetails: 'Chi tiết cấu hình sản phẩm',
  editDetails: 'Chỉnh sửa chi tiết',
  addProduct: 'Thêm sản phẩm',
  editProduct: 'Sửa sản phẩm',
  valid: 'Có hiệu lực',
  invalid: 'Vô hiệu',
  modify: 'Chỉnh sửa',
  inputProductName: 'Vui lòng nhập tên sản phẩm',
  selectReceiptMode: 'Vui lòng chọn chế độ thu',
  selectStatus: 'Vui lòng chọn trạng thái',
  selectProductType: 'Vui lòng chọn loại sản phẩm',
  feeRateName: 'Tên phí',
  fixedAmount: 'Số tiền cố định',
  fixedRate: 'Tỷ lệ phí cố định',
  allow: 'Cho phép',
  notAllow: 'Không cho phép',
  periodDuration: 'Thời hạn kỳ',
  eachPeriodDuration: 'Thời hạn mỗi kỳ',
  maxAmount: 'Số tiền tối đa',
  minAmount: 'Số tiền tối thiểu',
  incrAmount: 'Số tiền tăng thêm',
  incrQuota: 'Hạn mức tăng',
  allowDiferTime: 'Cho phép thời gian hoãn',
  allowPrepay: 'Cho phép trả trước',
  serviceFeeRate: 'Tỷ lệ phí dịch vụ',
  diferFeeRate: 'Phí dịch vụ gia hạn',
  overdueRate: 'Tỷ lệ quá hạn',
  dayInterestRate: 'Lãi suất ngày',
  ivaFee: 'Phí IVA',
  addConfig: 'Thêm cấu hình',
  editConfig: 'Sửa cấu hình',
  sort: 'Sắp xếp',
  type: 'Loại',
  configName: 'Tên cấu hình',
  configContent: 'Nội dung cấu hình',
  inputSort: 'Vui lòng nhập thứ tự sắp xếp!',
  inputType: 'Vui lòng nhập loại!',
  inputConfigName: 'Vui lòng nhập tên cấu hình!',
  inputConfigContent: 'Vui lòng nhập nội dung cấu hình!',
  sortPlaceholder: 'Giá trị càng nhỏ càng ưu tiên',
  applyAmountWeight: 'Trọng số tiền gốc (Ví dụ: 1,1,1)',
  serviceFeeWeight: 'Trọng số phí dịch vụ (Ví dụ: 1,1,1)',
  inputPeriodDuration: 'Vui lòng nhập kỳ hạn!',
  inputEachPeriodDuration: 'Vui lòng nhập thời hạn mỗi kỳ!',
  inputApplyAmountWeight: 'Vui lòng nhập trọng số tiền gốc!',
  inputServiceFeeWeight: 'Vui lòng nhập trọng số phí dịch vụ!',
  inputMaxAmount: 'Vui lòng nhập số tiền tối đa!',
  inputMinAmount: 'Vui lòng nhập số tiền tối thiểu!',
  inputIncrAmount: 'Vui lòng nhập số tiền tăng dần!',
  inputIncrQuota: 'Vui lòng nhập hạn mức tăng!',
  inputAllowDiferTime: 'Vui lòng nhập thời gian hoãn cho phép!',
  inputAllowPrepay: 'Vui lòng nhập có cho phép trả trước không!',
  inputServiceFeeRate: 'Vui lòng nhập tỷ lệ phí dịch vụ!',
  inputDiferFeeRate: 'Vui lòng nhập tỷ lệ phí hoãn!',
  inputOverdueRate: 'Vui lòng nhập tỷ lệ quá hạn!',
  inputDayInterestRate: 'Vui lòng nhập lãi suất ngày!',
  inputIvaFee: 'Vui lòng nhập phí IVA!',
  waitingForFullBid: 'Đang chờ đủ thầu',
  fullBid: 'Đã đủ thầu',
  failedBid: 'Hủy thầu',
  completed: 'Đã hoàn thành',
  disbursementSuccess: 'Giải ngân thành công',
  unknown: 'Không xác định',
  thirdPartyTransactionNo: 'Mã giao dịch đối tác',
  businessTransactionNo: 'Mã giao dịch nghiệp vụ',
  orderNo: 'Mã đơn vay',
  paymentLink: 'Liên kết thanh toán',
  email: 'Email',
  date: 'Ngày',
  channel: 'Kênh',
  isReductionAmt: 'Xác nhận giảm?',
  lateFee: 'Phí trễ hạn: ',
  reductionAmount: 'Số tiền giảm: ',
  inputReductionAmount: 'Số tiền giảm không được để trống',
  reductionAmountError: 'Số tiền giảm không được lớn hơn phí trễ hạn',
  isSettle: 'Xác nhận hoàn trả ngoại tuyến?',
  verifyPassword: 'Xác thực mật khẩu: ',
  inputPassword: 'Mật khẩu không được để trống',
  confirmExtendOffline: 'Xác nhận hoàn trả gia hạn ngoại tuyến?',
  platformOrderNo: 'Mã đơn nền tảng',
  repaymentCode: 'Mã thanh toán',
  mobileNo: 'Số điện thoại',
  orderId: 'ID đơn hàng',
  transactionType: 'Loại giao dịch',
  transactionAmount: 'Số tiền giao dịch',
  couponAmount: 'Số tiền giảm giá',
  createTime: 'Thời gian tạo',
  updateTime: 'Thời gian cập nhật',
  all: 'Tất cả',
  newCustomer: 'Khách hàng mới',
  oldCustomer: 'Khách hàng cũ',
  normalOrder: 'Đơn hàng bình thường',
  extensionOrder: 'Đơn hàng gia hạn',
  orderType: 'Loại đơn vay',
  minApplyAmount: 'Số tiền đăng ký (Tối thiểu)',
  maxApplyAmount: 'Số tiền đăng ký (Tối đa)',
  loanCountNum: 'Số lần vay',
  periodCount: 'Kỳ hạn',
  totalPeriod: 'Tổng số kỳ',
  applyDuration: 'Số kỳ mỗi khoản',
  feeRate: 'Mức phí',
  mainPackageProduct: 'Sản phẩm gói chính',
  multiLoanProduct: 'Sản phẩm đa khoản vay',
  firstLoan: 'Khoản vay đầu tiên',
  repeatLoan: 'Tái vay',
  components: {
    total: 'Tổng',
    items: 'Mục',
  },

  home: {
    title: 'Trang chủ',
    modifyPassword: 'Đổi mật khẩu',
    userInfoFail: 'Lỗi lấy thông tin người dùng, vui lòng thử lại',
    signOutInfo: 'Bạn có chắc muốn đăng xuất không?',
    userNameTips: 'Vui lòng nhập tài khoản đăng nhập',
    passwordTips: 'Vui lòng nhập mật khẩu đăng nhập',
    // code:"Veuillez entrer le Code de vérification",
    code: "Vui lòng nhập mã xác thực Google",
    earlyMorning: 'Sáng sớm',
    morning: 'Chào buổi sáng',
    noon: 'Chào buổi trưa',
    afternoon: 'Chào buổi chiều',
    evening: 'Chào buổi tối',
    welcome: 'Xin chào! Một ngày bận rộn nữa lại bắt đầu, cùng cố gắng nhé!',
    welcomeBack: 'Chào mừng trở lại',
    inputGoogleCode: 'Vui lòng nhập mã xác thực Google',
    bindGoogleCode: 'Làm thế nào để lấy mã xác thực Google?',
    okText: "Tôi đã liên kết",
    howToGetCode: '1. Tải ứng dụng Authenticator \n2. Mở ứng dụng Authenticator và quét mã để liên kết\n3. Sau khi liên kết thành công, bạn có thể xem mã xác thực trong ứng dụng Authenticator',
    checkAccount: 'Kiểm tra xem tài khoản của tôi đã liên kết mã Google hay chưa ?',
    check: 'Tra cứu',
    checkResult: 'Kết quả tra cứu',
    accountVerified: 'Tài khoản này đã được xác thực, vui lòng mở ứng dụng Authenticator để xem mã',
    accountNotVerified: 'Tài khoản này chưa xác thực, vui lòng tải Authenticator và quét mã để liên kết'
  },
  user: {
    settings: 'Cài đặt',
    changePassword: 'Đổi mật khẩu',
    logout: 'Đăng xuất',
    confirmLogout: 'Xác nhận đăng xuất',
    logoutConfirmContent: 'Bạn có chắc chắn muốn đăng xuất không?',
    passwordModified: 'Đổi mật khẩu thành công',
    passwordModifyFailed: 'Đổi mật khẩu thất bại',
    passwordNotMatch: 'Hai mật khẩu không khớp',
    oldPasswordRequired: 'Vui lòng nhập mật khẩu hiện tại',
    newPasswordRequired: 'Vui lòng nhập mật khẩu mới',
    confirmPasswordRequired: 'Xác nhận mật khẩu mới',
    passwordMinLength: 'Độ dài mật khẩu phải có ít nhất 6 ký tự',
    originalPassword: 'Mật khẩu hiện tại',
    newpassword: 'Mật khẩu mới',
    confirmNewPassword: 'Xác nhận mật khẩu mới',
    cancel: 'Hủy',
    confirm: 'Xác nhận'
  },
  language: {
    switchLanguage: 'Chuyển đổi ngôn ngữ',
    switchSuccess: 'Chuyển đổi ngôn ngữ thành công'
  },
  common: {
    ok: 'Đồng ý',
    cancel: 'Hủy'
  },
  customer: customer.es,
  system: {
    title: 'Cài đặt hệ thống',
    menuList: {
      menu: 'Menu',
      title: 'Quản lý menu hệ thống',
      index: 'SST',
      menuName: 'Tên menu',
      icon: 'Biểu tượng menu',
      type: 'Loại menu',
      superiorMenu: 'Menu cha',
      menuUrl: 'Đường dẫn menu',
      menuComponent: 'Thành phần menu',
      sort: 'Thứ tự hiển thị',
      action: 'Thao tác',
      edit: 'Chỉnh sửa',
      delete: 'Xóa',
      add: 'Thêm',
      mainSub: 'Menu cấp 1',
      submenu: 'Thêm menu con',
      buttonPermission: 'Nút / Quyền',
      nameEn: 'Tên tiếng Anh',
      preMenu: 'Menu cha',
      menuCode: 'Mã phân quyền',
    },
    userList: {
      title: 'Quản lý tài khoản đăng nhập',
      index: 'SST',
      name: 'Tên người dùng',
      phone: 'Số điện thoại',
      mail: 'Email',
      time: 'Thời gian tạo',
      position: 'Phòng ban/Vị trí',
      role: 'Vai trò',
      app: 'Ứng dụng',
      status: 'Trạng thái',
      action: 'Thao tác',
      add: 'Thêm',
      edit: 'Chỉnh sửa',
      password: 'Mật khẩu',
      delete: 'Xoá',
      callUserName: 'Tên đại lý',
      callUserPassword: 'Mật khẩu đại lý',
      resetGoogleAuth: 'Đặt lại mã xác thực Google',
      viewGoogleAuth: 'Xem G-auth',
      addUser: 'Thêm người dùng',
      editUser: 'Sửa người dùng',
      resetAuthenticator: 'Đặt lại xác thực',
      confirmResetAuthenticator: 'Xác nhận đặt lại xác thực?',
      deleteUser: 'Xóa người dùng',
      confirmDeleteUser: 'Xác nhận xóa người dùng hiện tại?'
    },
    roleList: {
      title: 'Quyền hạn & vai trò',
      index: 'SST',
      type: 'Loại vai trò',
      name: 'Tên vai trò',
      code: 'Mã vai trò',
      description: 'Mô tả vai trò',
      time: 'Thời gian tạo',
      action: 'Thao tác',
      add: 'Thêm',
      edit: 'Chỉnh sửa',
      password: 'Mật khẩu',
      delete: 'Xoá',
      permission: 'Phân quyền',
    },
    parameterConfiguration: {
      title: 'Cấu hình trung tâm CSKH',
      loanApp: 'Ứng dụng cho vay',
      investApp: 'Ứng dụng đầu tư',
      edit: 'Chỉnh sửa',
      cancel: 'Hủy',
      save: 'Lưu',
      contactPhone: 'Số điện thoại CSKH:',
      whatsappAccount: 'Tài khoản Zalo CSKH:',
      email: 'Email CSKH:',
      inputPlaceholder: 'Vui lòng nhập',
      fillAtLeastOne: 'Vui lòng nhập ít nhất một thông tin',
      canceled: 'Đã hủy',
      saved: 'Lưu thành công',
      fieldName: 'Tên trường',
      enabled: 'Bật',
      maxLength: 'Độ dài tối đa',
      description: 'Mô tả',
    },

  },
  investorList: {
    s1: 'Xin chào! Một ngày bận rộn nữa lại bắt đầu, cùng cố gắng nhé!',
    s2: 'Phễu chuyển đổi khách hàng mới',
    s3: 'Phễu chuyển đổi người dùng mới',
    s4: 'Giám sát đăng ký của người vay',
    s5: 'Giám sát đăng nhập của người vay',
    s6: 'Dữ liệu chuyển đổi tái vay của khách hàng cũ',
    s7: 'Dữ liệu chuyển đổi giải ngân tái vay của khách hàng cũ',
    s8: 'Tạo menu/nút',
    s9: 'Vui lòng chọn menu để xem chi tiết',
    s10: 'Loại menu:',
    s11: 'Tên menu:',
    s12: 'Đường dẫn menu:',
    s13: 'Thành phần:',
    s14: 'Biểu tượng menu:',
    s15: 'Thứ tự hiển thị:',
    s16: 'Trạng thái:',
    s17: 'Hiển thị',
    s18: 'Ẩn',
    s19: 'vai trò hệ thống',
    s20: 'vai trò ứng dụng',
    s21: 'Cấu hình quyền',
    s22: 'Vui lòng chọn ngày',
    Downloadinvoice: 'Tải hóa đơn',
    Downloadcontract: 'Tải hợp đồng',
    DownloadInvestmentContract: 'Tải hợp đồng đầu tư',
    downloading: 'Đang tải xuống, vui lòng đợi...',

    // Operation Center - Loan App Conversion Monitoring
    operationCenter: 'Trung tâm vận hành',
    loanAppConversion: 'Giám sát chuyển đổi của App vay',
    newUserConversionSummary: 'Tổng hợp dữ liệu chuyển đổi khách hàng mới',
    date: 'Ngày',
    cost: 'Chi phí',
    install: 'Lượt cài đặt',
    register: 'Lượt đăng ký',
    apply: 'Lượt nộp hồ sơ',
    approve: 'Lượt phê duyệt',
    disburse: 'Lượt giải ngân',
    installRegisterRate: 'Tỷ lệ chuyển đổi Cài đặt → Đăng ký',
    registerApplyRate: 'Tỷ lệ chuyển đổi Đăng ký → Nộp hồ sơ',
    applyApproveRate: 'Tỷ lệ chuyển đổi Nộp hồ sơ → Duyệt',
    applyDisburseRate: 'Tỷ lệ chuyển đổi Nộp hồ sơ → Giải ngân',
    approveDisburseRate: 'Tỷ lệ chuyển đổi Duyệt → Giải ngân',
    costPerInstall: 'Chi phí cho mỗi lượt cài đặt',
    costPerRegister: 'Chi phí cho mỗi lượt đăng ký',
    costPerApply: 'Chi phí cho mỗi hồ sơ',
    costPerApprove: 'Chi phí cho mỗi lượt được duyệt',
    costPerDisburse: 'Chi phí cho mỗi lượt giải ngân',
    newUserFunnel: 'Phễu chuyển đổi khách hàng mới',
    app: 'APP',
    sendOtpCount: 'Số mã OTP đăng ký được gửi',
    basicInfo: 'Thông tin cơ bản',
    workInfo: 'Thông tin công việc',
    contact: 'Người tham chiếu',
    bigJson: 'JSON Lớn',
    idPhoto: 'Ảnh mặt trước của CMND/CCCD',
    facePhoto: 'Ảnh khuôn mặt',
    idInfo: 'Thông tin CMND/CCCD',
    receiveInfo: 'Thông tin nhận tiền',
    sendSmsRate: 'Tỷ lệ gửi SMS',
    registerRate: 'Tỷ lệ đăng ký',
    basicInfoRate: 'Tỷ lệ hoàn thành thông tin cơ bản',
    workInfoRate: 'Tỷ lệ hoàn thành thông tin công việc',
    contactRate: 'Tỷ lệ hoàn thành người tham chiếu',
    jsonRate: 'Tỷ lệ hoàn thành JSON',
    idPhotoRate: 'Tỷ lệ hoàn thành ảnh CMND/CCCD',
    facePhotoRate: 'Tỷ lệ hoàn thành ảnh khuôn mặt',
    idInfoRate: 'Tỷ lệ hoàn thành thông tin CCCD',
    receiveInfoRate: 'Tỷ lệ hoàn thành thông tin nhận tiền',
    applyRate: 'Tỷ lệ nộp hồ sơ',
    passRate: 'Tỷ lệ qua duyệt',
    disburseRate: 'Tỷ lệ giải ngân',
    registerBindCardRate: 'Tỷ lệ chuyển đổi Đăng ký → Liên kết thẻ',
    registerDisburseRate: 'Tỷ lệ chuyển đổi Đăng ký → Giải ngân',
    borrowerRegisterMonitor: 'Giám sát đăng ký của người vay',
    conversion: 'Chuyển đổi',
    submitUnregisteredUnique: 'Số lượng số điện thoại chưa đăng ký (sau khi loại trùng)',
    submitUnregisteredCount: 'Số lần gửi số điện thoại chưa đăng ký',
    avgSubmitCount: 'Số lần gửi trung bình',
    submitValidUnregisteredUnique: 'Số lượng số điện thoại hợp lệ chưa đăng ký (sau khi loại trùng)',
    submitValidRate: 'Tỷ lệ số điện thoại hợp lệ',
    sendRegisterOtpCount: 'Số tin nhắn OTP đăng ký được gửi',
    sendRegisterOtpUnique: 'Số lượng số điện thoại nhận OTP (loại trùng)',
    avgOtpPerNumber: 'Số OTP trung bình/ mỗi số điện thoại',
    registerSuccessCount: 'Số lượng số điện thoại đăng ký thành công',
    registerFailCount: 'Số lượng số điện thoại đăng ký thất bại',
    notRequestLoginCount: 'Số lượng số điện thoại chưa gửi yêu cầu đăng nhập',
    lockOtpExhaustCount: 'Số lượng số điện thoại bị khóa OTP do dùng hết lượt OTP',
    lockUnregisteredCount: 'Số lượng số điện thoại bị khóa nhưng chưa đăng ký thành công',
    registerSuccessRateByCount: 'Tỷ lệ đăng ký thành công (theo lượt thực hiện)',
    registerSuccessRateByNumber: 'Tỷ lệ đăng ký thành công (theo số điện thoại)',
    borrowerLoginMonitor: 'Giám sát đăng nhập của người vay',
    submitLoginUnique: 'Số lượt gửi mã đăng nhập (đã loại trùng)',
    submitLoginCount: 'Số lần gửi mã đăng nhập',
    submitValidUnique: 'Số lượt gửi số hợp lệ (đã loại trùng)',
    sendOtpSmsCount: 'Số SMS OTP đã gửi',
    sendOtpUnique: 'Số thuê bao nhận OTP (đã loại trùng)',
    avgOtpPerSubscriber: 'Số OTP trung bình/thuê bao',
    loginSuccessCount: 'Số thuê bao đăng nhập thành công',
    loginFailCount: 'Số thuê bao đăng nhập thất bại',
    notRequestLoginInterfaceCount: 'Số thuê bao không gửi yêu cầu đăng nhập',
    lockOtpExhaustSubscriberCount: 'Số thuê bao bị khóa do dùng hết lượt OTP',
    lockUnloginCount: 'Số thuê bao bị khóa nhưng chưa đăng nhập',
    loginSuccessRateByCount: 'Tỷ lệ đăng nhập thành công (theo lượt thực hiện)',
    loginSuccessRateByNumber: 'Tỷ lệ đăng nhâp thành công (theo số điện thoại)',
    oldCustomerReborrowApply: 'Dữ liệu chuyển đổi tái vay của khách hàng cũ',
    actualRepayDate: 'Ngày hoàn trả thực tế',
    settledCount: 'Số khoản đã tất toán',
    reborrowOnRepayDay: 'Tái vay trong ngày hoàn trả',
    reborrowOnDay2: 'Tái vay sau ngày hoàn trả +2',
    reborrowOnDay3: 'Tái vay sau ngày hoàn trả +3',
    reborrowOnDay4: 'Tái vay sau ngày hoàn trả +4',
    reborrowOnDay5: 'Tái vay sau ngày hoàn trả +5',
    reborrowOnDay6: 'Tái vay sau ngày hoàn trả +6',
    reborrowOnDay7: 'Tái vay sau ngày hoàn trả +7',
    totalReborrowCount: 'Tổng số khoản tái vay',
    firstDayReborrowRate: 'Tỷ lệ tái vay trong ngày hoàn trả',
    day7ReborrowRate: 'Tỷ lệ tái vay sau 7 ngày',
    day10ReborrowRate: 'Tỷ lệ tái vay sau 10 ngày',
    day15ReborrowRate: 'Tỷ lệ tái vay sau 15 ngày',
    reborrowRate: 'Tỷ lệ tái vay tổng',
    oldCustomerReborrowDisburse: 'Dữ liệu chuyển đổi giải ngân tái vay của khách hàng cũ',
    actualRepayLoanCount: 'Số khoản hoàn trả thực tế',
    // Investment App Conversion Monitoring
    investmentAppConversion: 'Giám sát chuyển đổi trên ứng dụng đầu tư',
    investNewUserSummary: 'Tổng hợp chuyển đổi người dùng mới',
    participateBidCount: 'Số người tham gia đầu tư',
    bidSuccessCount: 'Số người đầu tư thành công',
    installRegisterConvertRate: 'Tỉ lệ chuyển đổi từ cài đặt → đăng ký',
    registerParticipateConvertRate: 'Tỉ lệ chuyển đổi từ đăng ký → tham gia đầu tư',
    participateSuccessConvertRate: 'Tỉ lệ chuyển đổi từ tham gia → đầu tư thành công',
    subtotal: 'Tổng số',
    investNewUserFunnel: 'Phễu chuyển đổi người dùng mới',
    login: 'Đăng nhập',
    completeAccountCount: 'Số người hoàn tất mở tài khoản',
    completeRiskAssessCount: 'Số người hoàn tất đánh giá rủi ro',
    rechargeCount: 'Số người nạp tiền',
    investorRegisterMonitor: 'Giám sát đăng ký của nhà đầu tư',
    submitUnregisteredInvestorUnique: 'Số lượng số điện thoại chưa đăng ký (đã loại bỏ trùng)',
    submitUnregisteredInvestorCount: 'Số lần gửi số điện thoại chưa đăng ký',
    avgSubmitInvestorCount: 'Số lần gửi trung bình trên mỗi người dùng',
    submitValidUnregisteredInvestorUnique: 'Số lượng số điện thoại hợp lệ – chưa đăng ký (đã loại bỏ trùng)',
    submitValidInvestorRate: 'Tỷ lệ số điện thoại hợp lệ trong tổng số gửi lên',
    sendRegisterOtpInvestorCount: 'Số lượng SMS gửi mã OTP đăng ký',
    sendRegisterOtpInvestorUnique: 'Số lượng số điện thoại nhận OTP (đã loại bỏ trùng)',
    avgOtpPerInvestorNumber: 'Số SMS OTP trung bình gửi cho mỗi số',
    registerSuccessInvestorCount: 'Số lượng số điện thoại đăng ký thành công',
    registerFailInvestorCount: 'Số lượng số điện thoại đăng ký thất bại',
    notRequestLoginInvestorCount: 'Số điện thoại không gọi API đăng nhập (sau bước đăng ký)',
    lockOtpExhaustInvestorCount: 'Số điện thoại bị khóa OTP do nhập sai quá số lần quy định',
    lockUnregisteredInvestorCount: 'Số điện thoại chưa đăng ký nhưng bị khóa OTP',
    registerSuccessInvestorRateByCount: 'Tỷ lệ đăng ký thành công (tính theo lượt)',
    registerSuccessInvestorRateByNumber: 'Tỷ lệ đăng ký thành công (tính theo số điện thoại)',
    investorLoginMonitor: 'Giám sát đăng nhập của nhà đầu tư',
    submitLoginInvestorUnique: 'Số lượng số điện thoại gửi yêu cầu đăng nhập (đã loại trừ trùng lặp)',
    submitLoginInvestorCount: 'Tổng số lần gửi số điện thoại để đăng nhập',
    avgSubmitLoginInvestorCount: 'Số lần gửi trung bình trên mỗi số điện thoại',
    submitValidInvestorUnique: 'Số lượng số điện thoại hợp lệ (đã loại trừ trùng lặp)',
    submitValidInvestorLoginRate: 'Tỷ lệ số điện thoại hợp lệ trên tổng số gửi lên',
    sendOtpInvestorSmsCount: 'Số lượng SMS OTP đã gửi đi',
    sendOtpInvestorUnique: 'Số lượng số điện thoại nhận OTP (đã loại trừ trùng lặp)',
    avgOtpPerInvestorSubscriber: 'Số lượng OTP trung bình gửi trên mỗi số',
    loginSuccessInvestorCount: 'Số lượng số điện thoại đăng nhập thành công',
    loginFailInvestorCount: 'Số lượng số điện thoại đăng nhập thất bại',
    notRequestLoginInvestorInterfaceCount: 'Số điện thoại không gọi API đăng nhập sau khi gửi OTP',
    lockOtpExhaustInvestorSubscriberCount: 'Số điện thoại bị khóa OTP do nhập sai quá số lần quy định',
    lockUnloginInvestorCount: 'Số điện thoại bị khóa OTP nhưng chưa đăng nhập thành công',
    loginSuccessInvestorRateByCount: 'Tỷ lệ đăng nhập thành công (theo lượt)',
    loginSuccessInvestorRateByNumber: 'Tỷ lệ đăng nhập thành công (theo số điện thoại)',
    // Complaints & Feedback
    complaintAndFeedback: 'Khiếu nại & Phản hồi',
    loanAppComplaintList: 'Danh sách khiếu nại App vay',
    complaintTime: 'Thời gian khiếu nại',
    borrowerName: 'Họ tên người vay',
    borrowerAccount: 'Tài khoản người vay',
    complaintContent: 'Nội dung khiếu nại',
    isFollowed: 'Có được theo dõi hay không',
    isResolved: 'Đã giải quyết hay chưa',
    lastFollower: 'Người theo dõi lần gần nhất',
    lastFollowRemark: 'Ghi chú theo dõi gần nhất',
    lastFollowTime: 'Thời gian theo dõi gần nhất',
    follow: 'Theo dõi',
    loanAppFeedbackList: 'Danh sách phản hồi App vay',
    feedbackTime: 'Thời gian phản hồi',
    problemType: 'Loại vấn đề',
    problemDesc: 'Mô tả vấn đề',
    voucher: 'Tài liệu đính kèm',
    // Asset Package Product Management
    assetPackageProduct: 'Quản lý sản phẩm trong gói tài sản',
    productSpecList: 'Danh sách đặc tính sản phẩm',
    productName: 'Tên sản phẩm',
    receiptMode: 'Thu phí trước / thu phí sau',
    status: 'Trạng thái',
    productType: 'Loại sản phẩm',
    action: 'Thao tác',
    editDetails: 'Chỉnh sửa chi tiết',
    modify: 'Chỉnh sửa',
    complianceOfficerReview: 'Duyệt của cán bộ xét duyệt',
    pendingReviewSpec: 'Danh sách sản phẩm chờ duyệt',
    productNameLabel: 'Tên sản phẩm',
    type: 'Loại',
    productPublishDate: 'Ngày phát hành sản phẩm',
    details: 'Chi tiết',
    approve: 'Phê duyệt',
    reject: 'Từ chối',
    reviewedSpec: 'Danh sách sản phẩm đã duyệt',
    assetPackageProductList: 'Danh sách sản phẩm của gói tài sản',
    assetPackageId: 'Mã gói tài sản',
    productLogo: 'Logo của sản phẩm',
    assetPackageName: 'Tên gói tài sản',
    productAmount: 'Số tiền sản phẩm (đ)',
    investmentCycle: 'Chu kỳ đầu tư (ngày)',
    yieldRate: 'Lãi suất (theo năm)',
    assetPackageStatus: 'Trạng thái gói tài sản',
    assetPackageComposition: 'Cấu trúc gói tài sản',
    borrowerInfoQuery: 'Tra cứu thông tin khách vay',
    phoneNo: 'Số điện thoại',
    customerFirstName: 'customer.firstName',
    customerMiddleName: 'customer.middleName',
    idCard: 'Giấy tờ định danh',
    email: 'Email',
    registerTime: 'Thời gian đăng ký',
    appSsid: 'Mã thiết bị (appSSID)',
    appName: 'Tên ứng dụng',
    borrowerOrderQuery: 'Tra cứu đơn vay của người vay',
    orderNo: 'Mã đơn vay',
    names: 'Họ tên',
    appssid: 'Mã appssid',
    settleStatus: 'Trạng thái tất toán',
    applyAmount: 'Số tiền đăng ký vay',
    period: 'Kỳ hạn',
    disburseDetailQuery: 'Tra cứu chi tiết giải ngân',
    businessTransNo: 'Mã giao dịch nghiệp vụ',
    thirdPartyTransNo: 'Mã giao dịch đối tác',
    channel: 'Kênh',
    repayDetailQuery: 'Tra cứu chi tiết hoàn trả',
    orderId: 'ID đơn vay',
    repaymentCode: 'Mã thanh toán',
    transactionType: 'Loại giao dịch',
    platformOrderNo: 'Mã đơn nền tảng',
    transactionAmount: 'Số tiền giao dịch',
    couponAmount: 'Số tiền giảm giá',
    createTime: 'Thời gian tạo',
    updateTime: 'Thời gian cập nhật',
    // Loan Data Report
    loanDataReport: 'Báo cáo dữ liệu khoản vay',
    dailyDisburseReport: 'Báo cáo giải ngân hằng ngày',
    disburseTime: 'Thời gian giải ngân',
    disburseCount: 'Số lượng khoản vay đã giải ngân',
    newCustomerCount: 'Số khoản vay của khách hàng mới',
    newCustomerAvg: 'Giá trị trung bình mỗi khoản vay của khách hàng mới',
    oldCustomerCount: 'Số khoản vay của khách hàng cũ',
    oldCustomerAvg: 'Giá trị trung bình mỗi khoản vay của khách hàng cũ',
    oldCustomerRatio: 'Tỷ trọng khách hàng cũ',
    disbursePrincipal: 'Tổng số tiền giải ngân',
    newCustomerDisbursePrincipal: 'Tổng tiền giải ngân cho khách hàng mới',
    oldCustomerDisbursePrincipal: 'Tổng tiền giải ngân cho khách hàng cũ',
    disburseContractAmount: 'Tổng giá trị hợp đồng vay',
    newCustomerContractAmount: 'Giá trị hợp đồng vay của khách hàng mới',
    oldCustomerContractAmount: 'Giá trị hợp đồng vay của khách hàng cũ',
    userType: 'Loại khách hàng',
    orderType: 'Loại giao dịch',
    dailyDueReport: 'Báo cáo đến hạn hằng ngày',
    periodCount: 'Kỳ hạn',
    dueRepayCount: 'Số khoản vay đến hạn phải trả',
    earlyRepayCount: 'Số khoản trả trước hạn',
    normalRepayOnDueDate: 'Số khoản trả đúng hạn trong ngày',
    overdueRepay: 'Số khoản trả khi đã quá hạn',
    overdueUnpaid: 'Số khoản vẫn chưa trả sau hạn',
    firstOverdue: 'Số khoản rơi vào quá hạn lần đầu',
    realTimeOverdueRate: 'Tỷ lệ quá hạn thời gian thực',
    firstOverdueAmount: 'Số tiền của khoản quá hạn lần đầu',
    realTimeOverdueRateAmount: 'Tỷ lệ quá hạn thực tế (số tiền)',
    earlyRepayRate: 'Tỷ lệ trả trước hạn',
    repayOnDueDateRate: 'Tỷ lệ trả đúng ngày',
    overdueRepayRate: 'Tỷ lệ trả sau hạn',
    collectionRecoveryRate: 'Tỷ lệ thu hồi',
    lastPeriodUncleared: 'Số khoản từ kỳ trước chưa tất toán',
    firstOverdueLastPaid: 'Khoản quá hạn lần đầu (theo kỳ đã tất toán)',
    badDebtLastPaid: 'Nợ xấu (tính theo kỳ đã tất toán)',
    extensionRate: 'Tỷ lệ gia hạn kỳ vay',
    overdueExtensionRate: 'Tỷ lệ gia hạn đối với khoản đã quá hạn',
    query: 'Xác minh',
    firstLoan: 'Khoản vay đầu tiên',
    repeatLoan: 'Tái vay',
    reset: 'Làm mới',
    minApplyAmount: 'Số tiền đăng ký (tối thiểu)',
    maxApplyAmount: 'Số tiền đăng ký (tối đa)',
    loanCount: 'Số lần vay',
    totalPeriods: 'Tổng số kỳ',
    periodPerLoan: 'Số kỳ mỗi khoản',
    feeRate: 'Mức phí',
    // Investor Center
    investorCenter: 'Trung tâm nhà đầu tư',
    investorManagement: 'Quản lý nhà đầu tư',
    investorInfoQuery: 'Tra cứu thông tin nhà đầu tư',
    investorId: 'Mã ID nhà đầu tư',
    name: 'Họ tên',
    account: 'Tài khoản',
    isRealNameVerified: 'Đã hoàn tất xác minh danh tính hay chưa',
    isRiskAssessed: 'Đã hoàn tất đánh giá rủi ro hay chưa',
    riskPreference: 'Khẩu vị rủi ro',
    enable: 'Kích hoạt',
    disable: 'Vô hiệu hóa',
    investmentOrgQuery: 'Tra cứu thông tin tổ chức đầu tư',
    investorOrgId: 'Mã ID tổ chức',
    orgName: 'Tên tổ chức',
    investmentOrderQuery: 'Tra cứu đơn đầu tư',
    investmentOrderNo: 'Mã đơn đầu tư',
    investorName: 'Tên nhà đầu tư',
    investorAccount: 'Tài khoản nhà đầu tư',
    investorType: 'Loại nhà đầu tư',
    investmentProductId: 'Mã sản phẩm đầu tư',
    investmentAmount: 'Số tiền đầu tư',
    investmentStatus: 'Trạng thái đầu tư',
    returnRate: 'Tỷ suất lợi nhuận',
    investmentCycle: 'Kỳ hạn (ngày)',
    expectedProfit: 'Lợi nhuận dự kiến',
    platformServiceFee: 'Phí dịch vụ nền tảng',
    investmentTime: 'Thời gian đầu tư',
    remark: 'Ghi chú',
    investorTradeCenter: 'Trung tâm giao dịch dành cho nhà đầu tư',
    overview: 'Tổng quan',
    rechargeCount: 'Số giao dịch nạp',
    rechargeAmount: 'Tổng tiền nạp',
    subscribeCount: 'Số giao dịch mua sản phẩm',
    subscribeAmount: 'Tổng số tiền mua',
    disburseCount: 'Số giao dịch giải ngân',
    disburseAmount: 'Số tiền giải ngân',
    investmentDueProduct: 'Sản phẩm sắp đáo hạn',
    dueUnfreezeAmount: 'Số tiền giải toả khi đáo hạn',
    withdrawAmount: 'Tổng tiền rút',
    today: 'Hôm nay',
    rechargeRecord: 'Lịch sử nạp tiền',
    rechargeSerialNo: 'Mã giao dịch nạp',
    rechargeStatus: 'Trạng thái nạp',
    freezeRecord: 'Lịch sử phong tỏa',
    freezeAmount: 'Số tiền bị phong tỏa',
    freezeReason: 'Lý do phong tỏa',
    freezeTime: 'Thời gian phong toả',
    matchTradeRecord: 'Lịch sử khớp kết nối',
    matchDate: 'Ngày khớp kết nối',
    productId: 'Mã sản phẩm',
    productName: 'Tên sản phẩm',
    loanOrderNo: 'Mã đơn vay',
    borrowerName: 'Tên người vay',
    borrowerAccount: 'Tài khoản người vay',
    loanAmount: 'Số tiền vay',
    matchInvestOrderId: 'Mã đơn đầu tư đã khớp',
    investorName: 'Tên nhà đầu tư',
    matchAmount: 'Số tiền được khớp',
    profitDistRecord: 'Lịch sử phân phối lợi nhuận',
    investmentOrderId: 'Mã đơn đầu tư',
    investAmount: 'Số tiền đầu tư (d)',
    returnRate: 'Tỷ suất lợi nhuận',
    investCycle: 'Kỳ hạn đầu tư (ngày)',
    shouldSettleAmount: 'Số tiền dự kiến nhận',
    actualSettleAmount: 'Số tiền thực nhận',
    withdrawRecord: 'Lịch sử rút tiền',
    applyWithdrawTime: 'Thời gian yêu cầu rút',
    tradeSerialNo: 'Mã dòng tiền giao dịch',
    withdrawStatus: 'Trạng thái rút tiền',
    applyWithdrawAmount: 'Số tiền yêu cầu rút',
    handlingFee: 'Phí giao dịch',
    actualReceivedAmount: 'Số tiền thực nhận',
    withdrawBankAccount: 'Tài khoản ngân hàng nhận tiền',
    // Platform Rights Center
    platformRightsCenter: 'Trung tâm Quyền lợi Nền tảng',
    feeRightsConfig: 'Cấu hình Quyền lợi & Biểu phí',
    borrowerFeeConfig: 'Cấu hình Phí dành cho Người Vay',
    feeName: 'Tên khoản phí',
    serviceFee: 'Phí dịch vụ',
    chargeNode: 'Thời điểm thu phí',
    deductOnDisburse: 'Khấu trừ khi giải ngân',
    chargeOnRepay: 'Thu khi người vay trả nợ',
    chargeStandard: 'Quy tắc tính phí',
    loanRatio10Percent: 'Tính theo tỷ lệ khoản vay ví dụ 10%',
    fixedAmountPerLoan: 'Thu cố định cho mỗi khoản vay',
    edit: 'Chỉnh sửa',
    delete: 'Xoá',
    cancel: 'Huỷ',
    save: 'Lưu',
    investorFeeConfig: 'Cấu hình Phí dành cho Nhà Đầu Tư',
    applicableObject: 'Đối tượng phù hợp',
    individualInvestor: 'Nhà đầu tư cá nhân',
    enterpriseInvestor: 'Nhà đầu tư doanh nghiệp',
    chargeOnWithdraw: 'Thu khi rút tiền',
    chargeOnInvest: 'Thu khi đầu tư',
    chargeOnProfitDist: 'Thu khi phân phối lợi nhuận',
    chargeByInvestRatio10Percent: 'Thu theo tỷ lệ, ví dụ 10% trên số tiền đầu tư',
    fixedAmountPerInvest: 'Thu cố định mỗi lần đầu tư',
    investProfitXPercent: 'Thu x% lợi nhuận đầu tư',
    incomeDetail: 'Chi tiết thu phí',
    borrowerIncomeDetail: 'Chi tiết thu phí từ người vay',
    borrowerName: 'Tên người vay',
    account: 'Tài khoản',
    feeType: 'Loại phí',
    chargeTime: 'Thời điểm thu',
    chargeStandard: 'Tiêu chuẩn thu',
    receivableAmount: 'Số tiền phải thu',
    receivedAmount: 'Số tiền thực thu',
    chargeTime: 'Thời gian thu',
    investorIncomeDetail: 'Chi tiết thu phí từ nhà đầu tư',
    investorName: 'Tên nhà đầu tư',
    investorAccount: 'Tài khoản nhà đầu tư',
    investorType: 'Loại nhà đầu tư',
    // Statistics Center
    statisticsCenter: 'Trung tâm thống kê',
    dailyIncomeSummary: 'Báo cáo tổng hợp doanh thu hằng ngày',
    totalReceivable: 'Tổng số phải thu',
    totalReceived: 'Tổng số đã thu',
    borrowerReceivable: 'Khoản phải thu từ người vay',
    borrowerReceived: 'Khoản đã thu từ người vay',
    investorReceivable: 'Khoản phải thu của nhà đầu tư',
    investorReceived: 'Khoản đã thu của nhà đầu tư',
    // Collection Center
    collectionCenter: 'Trung tâm thu hồi nợ',
    collectionTeamManagement: 'Quản lý đội ngũ thu hồi nợ',
    collectionStaffAccount: 'Tài khoản nhân viên thu hồi nợ',
    serialNo: 'STT',
    userName: 'Tên người dùng',
    account: 'Tài khoản',
    seatNo: 'Số seat',
    createTime: 'Thời gian tạo',
    status: 'Trạng thái',
    modify: 'Chỉnh sửa',
    delete: 'Xóa',
    unbindSeat: 'Hủy liên kết seat',
    clearGaid: 'Xóa dữ liệu GAID',
    collectionLeaderAccount: 'Tài khoản trưởng nhóm thu hồi nợ',
    seatCode: 'Mã seat',
    collectionDeptManagement: 'Quản lý bộ phận thu hồi nợ',
    department: 'Phòng ban',
    create: 'Tạo mới',
    reset: 'Đặt lại',
    query: 'Tra cứu',
    collectionGroupManagement: 'Quản lý nhóm thu hồi nợ',
    groupName: 'Tên nhóm',
    leader: 'Trưởng nhóm',
    collectionStage: 'Giai đoạn thu hồi',
    memberCount: 'Số lượng thành viên',
    installmentType: 'Loại kỳ hạn',
    manage: 'Quản lý',
    collectorPerformanceBonus: 'Thưởng hiệu suất nhân viên thu hồi',
    exportPerformanceData: 'Xuất dữ liệu hiệu suất',
    collectionOrderQuery: 'Tra cứu đơn thu hồi nợ',
    orderId: 'Mã đơn hàng',
    application: 'Ứng dụng',
    orderNumber: 'Số đơn',
    customerName: 'Tên khách hàng',
    overdueDays: 'Số ngày quá hạn',
    collectionEntryTime: 'Thời gian vào danh sách thu hồi',
    followUpCount: 'Số lần theo dõi',
    collectorAccount: 'Tài khoản nhân viên thu hồi',
    follower: 'Người theo dõi',
    followResult: 'Kết quả theo dõi',
    repaymentWillingness: 'Mức độ thiện chí trả nợ',
    collectionTaskStatus: 'Trạng thái nhiệm vụ thu hồi',
    collectionStage: 'Giai đoạn thu hồi',
    action: 'Thao tác',
    collectionOrderDistribution: 'Quản lý phân đơn thu hồi',
    todayClaimedStaff: 'Nhân viên nhận đơn hôm nay',
    collectionStageName: 'Tên giai đoạn thu hồi',
    statisticsValue: 'Số liệu thống kê',
    prevDayStatistics: 'Số liệu ngày hôm trước',
    statisticsTime: 'Thời gian thống kê',
    department: 'Phòng ban',
    group: 'Nhóm',
    installmentType: 'Loại kỳ hạn',
    todayDistributionStatus: 'Tình hình phân đơn hôm nay',
    type: 'Loại',
    totalShouldCollect: 'Tổng số cần thu',
    totalDistributed: 'Tổng đã phân',
    totalUndistributed: 'Số chưa phân',
    undistributedNewCustomer: 'Số khách mới chưa phân',
    undistributedOldCustomer: 'Số khách cũ chưa phân',
    reAddToRedisQueue: 'Thêm lại vào hàng đợi Redis',
    distribute: 'Phân bổ',
    orderChangeCollector: 'Thay đổi nhân viên phụ trách thu hồi',
    app: 'APP',
    orderNo: 'Mã đơn',
    phoneNo: 'Số điện thoại',
    firstName: 'Tên',
    lastName: 'Họ',
    idCard: 'Giấy tờ',
    applyAmount: 'Số tiền vay',
    period: 'Kỳ hạn',
    settleStatus: 'Tình trạng tất toán',
    overdueStatus: 'Tình trạng quá hạn',
    disburseTime: 'Thời gian giải ngân',
    batchReclaimOrders: 'Danh sách đơn thu hồi hàng loạt',
    actualDueDate: 'Ngày đáo hạn thực tế',
    nonInstallment: 'Không chia kỳ',
    installment: 'Trả góp',
    customer: 'Khách hàng',
    all: 'Tất cả',
    newCustomer: 'Khách hàng mới',
    oldCustomer: 'Khách hàng cũ',
    orderCount: 'Số lượng đơn',
    reclaimed: 'Đã thu hồi',
    collecting: 'Đang trong quá trình thu hồi',
    collectionDataCenter: 'Trung tâm dữ liệu thu hồi nợ',
    collectorRecoveryReport: 'Báo cáo thu hồi của nhân viên',
    collectorAccount: 'Tài khoản nhân viên thu hồi',
    collector: 'Nhân viên thu hồi',
    collectorId: 'Mã nhân viên thu hồi',
    collectionGroup: 'Nhóm thu hồi',
    attendanceDays: 'Số ngày làm việc',
    totalAssigned: 'Tổng số đơn được phân',
    assignedAmount: 'Tổng số tiền được phân',
    pendingTotal: 'Tổng số cần xử lý',
    followingTotal: 'Tổng số đang theo dõi',
    cancelledTotal: 'Tổng số huỷ',
    recoveredTotal: 'Tổng số đã thu hồi',
    extensionCount: 'Số đơn gia hạn',
    recoveredAmountContract: 'Số tiền thu hồi (theo hợp đồng)',
    recoveryRateByOrder: 'Tỷ lệ thu hồi (theo đơn)',
    recoveryRateByContract: 'Tỷ lệ thu hồi (theo giá trị hợp đồng)',
    recoveredAmountActual: 'Số tiền thu hồi thực tế',
    recoveryRateByPayment: 'Tỷ lệ thu hồi (theo số tiền trả)',
    extensionRate: 'Tỷ lệ gia hạn',
    installmentType: 'Loại kỳ hạn',
    collectionEntryTime: 'Thời gian chuyển vào thu hồi',
    collectionExitTime: 'Thời gian kết thúc thu hồi',
    overdueDays: 'Số ngày quá hạn',
    collectionStage: 'Giai đoạn thu hồi',
    taskType: 'Loại nhiệm vụ',
    userType: 'Loại khách hàng',
    applyPeriod: 'Kỳ hạn đăng ký',
    installmentType: 'Loại hình trả góp',
    installmentAsAggregateCondition: 'Dùng trả góp làm điều kiện kết nối',
    export: 'Xuất dữ liệu',
    collectionGroupRecoveryReport: 'Báo cáo thu hồi theo nhóm thu hồi',
    deptName: 'Tên phòng ban',
    collectionGroup: 'Nhóm thu hồi',
    totalAssigned: 'Tổng số phân đơn',
    assignedAmount: 'Tổng số tiền phân đơn',
    pendingTotal: 'Tổng đơn chờ xử lý',
    followingTotal: 'Tổng đơn đang theo dõi',
    cancelledTotal: 'Tổng đơn hủy',
    recoveredTotal: 'Tổng đơn thu hồi',
    recoveredAmountContract: 'Số tiền thu hồi (hợp đồng)',
    recoveryRateByOrder: 'Tỷ lệ thu hồi (theo đơn)',
    installmentType: 'Loại trả góp',
    recoveredAmountActual: 'Số tiền thu hồi (thực tế)',
    recoveryRateByPayment: 'Tỷ lệ thu hồi (theo tiền đã trả)',
    recoveryRateByContract: 'Tỷ lệ thu hồi (theo hợp đồng)',
    collectionDeptRecoveryReport: 'Báo cáo thu hồi theo phòng ban',
    deptName: 'Tên phòng ban',
    totalAssigned: 'Tổng số phân đơn',
    pendingTotal: 'Tổng đơn chờ xử lý',
    followingTotal: 'Tổng đơn đang theo dõi',
    cancelledTotal: 'Tổng đơn hủy',
    recoveredTotal: 'Tổng đơn thu hồi',
    recoveredAmountContract: 'Số tiền thu hồi (hợp đồng)',
    recoveryRateByOrder: 'Tỷ lệ thu hồi (đơn)',
    recoveryRateByContract: 'Tỷ lệ thu hồi (theo hợp đồng)',
    recoveredAmountActual: 'Số tiền thu hồi (thực tế)',
    recoveryRateByPayment: 'Tỷ lệ thu hồi (theo tiền đã trả)',
    installmentType: 'Loại trả góp',
    dailyCollectionDataSummary: 'Tổng hợp dữ liệu thu hồi theo ngày',
    date: 'Ngày',
    totalAssigned: 'Tổng số phân đơn',
    assignedAmount: 'Số tiền phân đơn',
    recoveredTotal: 'Tổng đơn thu hồi',
    extensionCount: 'Số đơn gia hạn',
    recoveredAmountContract: 'Số tiền thu hồi (hợp đồng)',
    recoveredAmountActual: 'Số tiền thu hồi (thực tế)',
    recoveryRateByOrder: 'Tỷ lệ thu hồi (đơn)',
    recoveryRateByContract: 'Tỷ lệ thu hồi (theo hợp đồng)',
    // Telesales Management
    teleSalesManagement: 'Quản lý Telesales',
    teleSalesTaskDistribution: 'Phân công nhiệm vụ telesales',
    manualDistribution: 'Phân đơn thủ công',
    registerTime: 'Thời gian đăng ký',
    loanProduct: 'Sản phẩm vay',
    pleaseSelect: 'Vui lòng chọn',
    teleSalesType: 'Loại telesale',
    orderNotSubmitted: 'Đơn chưa gửi',
    register5to7HoursNotApply: 'Đăng ký 5–7 giờ chưa nộp',
    teleSalesStaff: 'Nhân viên telesale',
    generateUserGroup: 'Tạo nhóm người dùng',
    pleaseInput: 'Vui lòng nhập',
    autoDistribution: 'Phân đơn tự động',
    teleSalesTypeConfig: 'Cấu hình loại telesale',
    distributionType: 'Loại telesale',
    sendOtpNotLogin: 'Gửi mã OTP nhưng chưa đăng nhập',
    basicInfoNotSubmitted: 'Chưa gửi thông tin cơ bản',
    contactNotSubmitted: 'Chưa gửi thông tin liên hệ',
    idCardNotSubmitted: 'Chưa gửi thẻ ID',
    bankCardNotSubmitted: 'Chưa gửi thẻ ngân hàng',
    orderNotSubmitted: 'Đơn chưa gửi',
    register1to3HoursNotApply: 'Đăng ký 1–3 giờ chưa nộp',
    settled1to2DaysNotConvertNew: 'Khách mới tất toán 1–2 ngày chưa chuyển đổi',
    settled1to2DaysNotConvertOld: 'Khách cũ tất toán 1–2 ngày chưa chuyển đổi',
    settled1to7DaysNotConvert: 'Tất toán 1–7 ngày chưa chuyển đổi',
    firstLoanSettled90MinNotReborrow: 'Khách vay lần đầu – hết hạn 90 phút chưa vay lại',
    earlySettled1to2DaysNew: 'Khách mới – tất toán sớm 1–2 ngày',
    earlySettled1to2DaysOld: 'Khách cũ– tất toán sớm 1–2 ngày',
    disburseFail168HoursNotBindCardNew: 'Khách mới – giải ngân thất bại 168h chưa liên kết thẻ',
    disburseFail168HoursNotBindCardOld: 'Khách cũ – giải ngân thất bại 168h chưa liên kết thẻ',
    settled15to20DaysNotConvertCall404: 'Tất toán 15–20 ngày chưa chuyển đổi — gọi tự động 404',
    marketingC3DaysNotApply: 'Trong 3 ngày marketing phân loại C nhưng chưa nộp đơn',
    marketingC3DaysSettledNotConvert: 'Trong 3 ngày marketing phân loại C nhưng tất toán chưa chuyển đổi',
    teleSalesDistributionRecord: 'Nhật ký phân đơn telesale',
    batchNo: 'Mã đợt phân đơn',
    distributionTime: 'Thời gian phân đơn',
    distributionType: 'Loại phân nhóm',
    todayDistributionCount: 'Số đơn phân trong ngày',
    actualCount: 'Số lượng thực',
    package: 'Gói (APP)',
    period: 'Kỳ hạn (chỉ dùng cho tất toán sớm)',
    teleSalesStaff: 'Nhân viên telesale',
    parameter: 'Tham số',
    userGroupName: 'Tên nhóm người dùng',
    registerStartDate: 'Ngày bắt đầu đăng ký',
    registerEndDate: 'Ngày kết thúc đăng ký',
    teleSalesTeamManagement: 'Quản lý đội telesales',
    teleSalesStaffManagement: 'Quản lý nhân sự telesales',
    id: 'Mã ID',
    loginAccount: 'Tài khoản đăng nhập',
    seat: 'Ghế',
    name: 'Họ tên',
    cloudSeatAccount: 'Tài khoản cloud seat',
    cloudSeatPassword: 'Mật khẩu cloud seat',
    seatStatus: 'Trạng thái ghế',
    userGroup: 'Nhóm người dùng',
    createTime: 'Thời gian tạo',
    updateTime: 'Thời gian cập nhật',
    action: 'Thao tác',
    edit: 'Chỉnh sửa',
    more: 'Thêm tùy chọn',
    reclaim: 'Thu hồi',
    unbindCloudSeat: 'Gỡ liên kết cloud seat',
    teleSalesGroupManagement: 'Quản lý tổ telesale',
    id: 'ID',
    groupName: 'Tên tổ',
    status: 'Trạng thái',
    distributionLimit: 'Hạn mức phân đơn',
    teleSalesStaff: 'Nhân viên telesale',
    creator: 'Người tạo',
    createTime: 'Thời gian tạo',
    updater: 'Người cập nhật',
    updateTime: 'Thời gian cập nhật',
    typeConfig: 'Thời gian cập nhật',
    teleSalesStatistics: 'Thống kê telesale',
    staffEfficiencyReport: 'Báo cáo hiệu suất nhân viên telesale',
    date: 'Ngày',
    teleSalesStaff: 'Nhân viên telesale',
    distributionType: 'Loại phân phối',
    todayDistributionCount: 'Số đơn được phân trong ngày',
    loadCount: 'Lượng tải',
    followUpCount: 'Số đơn đã theo dõi',
    conversionCount: 'Số đơn chuyển đổi',
    conversionRate: 'Tỷ lệ chuyển đổi',
    passCount: 'Số đơn thông qua',
    passRate: 'Tỷ lệ thông qua',
    teleSalesConversionReport: 'Báo cáo chuyển đổi telesale',
    date: 'Ngày',
    teleSalesStaff: 'Nhân viên telesale',
    groupName: 'Tên nhóm',
    loanProduct: 'Sản phẩm vay',
    distributionType: 'Loại phân phối',
    todayDistributionCount: 'Số đơn phân trong ngày',
    dialCount: 'Số lần quay số',
    connectCount: 'Số cuộc gọi kết nối',
    phoneConnectCount: 'Số lần kết nối qua điện thoại',
    zaloConnectCount: 'Số kết nối qua Zalo',
    emailConnectCount: 'Số kết nối qua email',
    t0ConversionCount: 'Số chuyển đổi T0',
    t0ConversionRate: 'Tỷ lệ chuyển đổi T0',
    t0PassCount: 'Số thông qua T0',
    t0PassRate: 'Tỷ lệ thông qua T0',
    t1ConversionCount: 'Số chuyển đổi T1',
    t1ConversionRate: 'Tỷ lệ chuyển đổi T1',
    t1PassCount: 'Số thông qua T1',
    t1PassRate: 'Tỷ lệ thông qua T1',
    t2ConversionCount: 'Số chuyển đổi T2',
    t2ConversionRate: 'Tỷ lệ chuyển đổi T2',
    t2PassCount: 'Số thông qua T2',
    t2PassRate: 'Tỷ lệ thông qua T2',
    tzrID: 'Mã ID nhà đầu tư',
    mc: 'Họ tên',
    sjh: 'Số điện thoại',
    smrz: 'Đã hoàn tất xác minh danh tính hay chưa',
    fxpg: 'Đã hoàn tất đánh giá rủi ro hay chưa',
    sfzh: 'Giấy tờ định danh',
    fxdj: 'Mức độ rủi ro',
    tzddbh: 'Mã đơn đầu tư',
    tzzcbid: 'Mã sản phẩm đầu tư',
    tzrzh: 'Tài khoản nhà đầu tư',
    zt: 'Trạng thái',
    yx: 'Email',
    zcsj: 'Thời gian đăng ký',
    cz: 'Thao tác',
    xq: 'Chi tiết',
    jy: 'Vô hiệu hóa',
    qy1: 'Kích hoạt',
    ysz: 'Yes',
    wsz: 'No',
    ysg: 'Yes',
    wsg: 'No',
    zc: 'Kích hoạt',
    jy: 'Vô hiệu hóa',
    tzrmc: 'Tên nhà đầu tư',
    tzrzh: 'Tài khoản nhà đầu tư',
    tzrlx: 'Loại nhà đầu tư',
    tzzcbid: 'Mã sản phẩm đầu tư',
    tzje: 'Số tiền đầu tư',
    tzrzt: 'Trạng thái đầu tư',
    tzhbl: 'Tỷ suất lợi nhuận',
    tzzq: 'Kỳ hạn (ngày)',
    yqsy: 'Lợi nhuận dự kiến',
    ptffw: 'Phí dịch vụ nền tảng',
    tzsj: 'Thời gian đầu tư',
    gr: 'Cá nhân',
    qy: 'Doanh nghiệp',
    jg: 'Tổ chức',
    jr: 'Hôm nay',
    czbs: 'Số giao dịch nạp',
    czje: 'Số tiền nạp',
    rgbs: 'Số giao dịch mua sản phẩm',
    rgje: 'Tổng số tiền mua',
    fkbs: 'Số giao dịch giải ngân',
    fkje: 'Số tiền giải ngân',
    tzdqbd: 'Sản phẩm sắp đáo hạn',
    dqjdje: 'Số tiền giải toả khi đáo hạn',
    txje: 'Tổng tiền rút',
    czlsh: 'Mã giao dịch nạp',
    czsj: 'Thời gian nạp',
    cg: 'Thành công',
    sb: 'Thất bại',
    qb: 'Tất cả',
    czzt: 'Trạng thái nạp',
    djyy: 'Lý do phong tỏa',
    djsj: 'Thời gian phong toả',
    tzbd: 'Sản phẩm đầu tư',
    tzdj: 'đóng băng đầu tư',
    fqrg: 'Khởi động đầu tư',
    rgcg: 'Đầu tư thành công',
    rgsb: 'Đầu tư thất bại',
    fqtk: 'Khởi động hoàn trả',
    tkcg: 'Hoàn trả thành công',
    mb: 'Đầy đủ',
    zjchz: 'Xử lý tiền',
    yjs: 'Đã kết thúc',
    zcbid: 'Mã gói tài sản',
    zcbmc: 'Tên gói tài sản',
    zcbzt: 'Trạng thái gói tài sản',
    zcbdj: 'Hạng gói tài sản',
    bdje: 'Số tiền sản phẩm (đ)',
    syl: 'Lãi suất (theo năm)',
    zcbgc: 'Cấu trúc gói tài sản (khoản vay)',
    zcbgc1: 'Thành phần gói tài sản (Nhà đầu tư)',
    xgtzzt: 'Modify investment status',
    xgtzzt: 'Chỉnh sửa tình trạng đầu tư',
    tzzqt: 'Chu kỳ đầu tư (ngày)',
    jkrmx: 'Người vay',
    tzrmx: 'Nhà đầu tư',
    tzrmc: 'Tên nhà đầu tư',
    tzrxm: 'Họ và tên nhà đầu tư',
    pprq: 'Ngày khớp kết nối',
    zje: 'Tổng số tiền',
    jkrs: 'Số lượng người vay',
    tzrs: 'Số lượng nhà đầu tư',
    jkrmc: 'Tên người vay',
    jkrid: 'ID người vay',
    jkrsjh: 'Số điện thoại người vay',
    jkje: 'Số tiền vay',
    jkqx: 'Kỳ hạn vay (Ngày)',
    jkzt: 'Trạng thái khoản vay',
    nhll: 'Lãi suất hàng năm',
    tzzb: 'Tỷ lệ đầu tư',
    tzrsjh: 'Số điện thoại nhà đầu tư',
    lb: 'Hủy thầu',
    ddk: 'Chờ giải ngân',
    tzz: 'Đang đầu tư',
    jkz: 'Đang vay',
    hkz: 'Đang trả nợ',
    ywc: 'Đã hoàn thành',
    hkddh: 'Số đơn hàng/Mã đơn trả nợ',
    hkrxm: 'Tên bên trả nợ',
    hkrsjh: 'Số điện thoại người trả nợ',
    hkrzh: 'Số điện thoại người trả nợ',
    zjfpmx: 'Bảng phân bổ nguồn vốn',
    hkje: 'Số tiền trả nợ',
    fpje: 'Khoản phân bổ',
    ysze: 'Tổng số phải thu',
    ssze: 'Tổng số đã thu',
    jkrys: 'Khoản phải thu từ người vay',
    jkrss: 'Khoản đã thu từ người vay',
    tzrys: 'Khoản phải thu của nhà đầu tư',
    tzrss: 'Khoản đã thu của nhà đầu tư',
    sfsj: 'Thời gian thu',
    zh: 'Tài khoản',
    fymc: 'Loại phí',
    sfjd: 'Thời điểm thu',
    fkskc: 'khấu trừ khi giải ngân',
    hkssq: 'Thu khi trả nợ',
    sfbz: 'Tiêu chuẩn thu',
    ysje: 'Số tiền phải thu',
    ssje: 'Số tiền thực thu',
    sxrq: 'Ngày có hiệu lực',
    qsrzh: 'Vui lòng nhập tài khoản',
    czzh: 'Tài khoản nạp',
    czrq: 'Ngày nạp',
    czr: 'Người nạp',
    cjcz: 'Tạo nạp',
    qsrczje: 'Vui lòng nhập số tiền nạp',
    qsryhsjh: 'Vui lòng nhập số điện thoại người dùng',
    qsrbz: 'Vui lòng nhập ghi chú',
    jkrsjh: 'Số điện thoại người vay',
    djje: 'Số tiền phong tỏa',

  },
  order: order.es,
  account: {
    accountDetail: 'Chi tiết tài khoản',
  },
  postLoan: {
    title: 'Quản lý hậu cho vay',
  },
  approval: approval.en,
  collection: collection.es,
  remind: remind.en,
  risk: risk.en,
  repayReport: repayReport.es,
  repayOverDueReport: repayOverDueReport.en,
  collectorTotalFollow: collectorTotalFollow.en,
  other: {
    title: 'Khác',
  },
  platformCollection: platformCollection.es,
  custServiceWorkOrder: custServiceWorkOrder.es,
  teleMarket: teleMarket.es,
  custTrans: custTrans.es,
  custConvertReal: custConvertReal.es,
  reborrowCount: reborrowCount.es,
  coupon: coupon.es,
  repaycert: repaycert.es,
  borrowerCenter: {
    title: 'Trung tâm khách hàng vay',
    borrowerManagement: 'Quản lý khách hàng vay',
    basicInfo: 'Thông tin cơ bản',
    userId: 'ID người dùng',
    name: 'Họ tên',
    gender: 'Giới tính',
    idNo: 'Số CMND/CCCD',
    birthDate: 'Ngày sinh',
    monthlyIncome: 'Thu nhập hàng tháng',
    jobTitle: 'Chức danh',
    mobile: 'Số điện thoại',
    city: 'Thành phố',
    platformEvaluation: 'Đánh giá nền tảng',
    financialCapability: 'Khả năng tài chính',
    creditLevel: 'Cấp độ tín dụng',
    creditScore: 'Điểm tín dụng',
    conclusion: 'Kết luận',
    male: 'Nam',
    female: 'Nữ',
    pleaseInputEmail: 'Vui lòng nhập email!',
    // CustomerModifyModal translations
    customerInfo: 'Thông tin khách hàng',
    loginAccount: 'Tài khoản đăng nhập',
    idNumber: 'Số CMND/CCCD',
    birthDateTime: 'Ngày sinh',
    registrationTime: 'Thời gian đăng ký',
    basicInfoSection: 'Thông tin cơ bản',
    emailAddress: 'Email',
    residenceCity: 'Thành phố cư trú',
    detailedAddress: 'Địa chỉ chi tiết',
    maritalStatus: 'Tình trạng hôn nhân',
    workInfo: 'Thông tin công việc',
    occupation: 'Nghề nghiệp',
    employmentDate: 'Ngày vào làm',
    companyName: 'Tên công ty',
    workLocation: 'Nơi làm việc',
    companyPhone: 'Số điện thoại công ty',
    contactInfo: 'Thông tin liên hệ',
    firstContact: 'Người liên hệ thứ nhất',
    relationship: 'Mối quan hệ',
    contactPhone: 'Số điện thoại liên hệ',
    secondContact: 'Người liên hệ thứ hai',
    documentInfo: 'Thông tin giấy tờ',
    frontSide: 'Mặt trước',
    backSide: 'Mặt sau',
    facePhoto: 'Ảnh khuôn mặt',
    paymentAccountInfo: 'Thông tin tài khoản nhận tiền',
    bankName: 'Tên ngân hàng',
    accountNumber: 'Số tài khoản',
    accountHolderName: 'Tên chủ tài khoản',
    accountHolderIdNumber: 'Số CMND/CCCD chủ tài khoản',
    platformEvaluationSection: 'Đánh giá nền tảng',
    married: 'Đã kết hôn',
    unmarried: 'Chưa kết hôn',
  },
}